<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>{{$t('addGroup.admin')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('addGroup.addRole')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <h2>{{ accountInfo.companyName }}</h2>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-user"></i>&nbsp;{{$t('addGroup.role')}}</span>
      </div>
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <el-form-item :label="$t('addGroup.role')" prop="groupName">
          <el-input v-model="form.groupName" maxlength="50" style="width: 70%;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('addGroup.process')" prop="processID">
          <el-select v-model="form.processID" style="width: 70%;" multiple>
            <el-option :label="$t('addGroup.hint')" value=""></el-option>
            <el-option
              v-for="item in processList"
              v-bind:key="item.id"
              v-bind:label="item.name"
              v-bind:value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">{{$t('addGroup.add')}}</el-button>
          <el-button @click="resetForm()">{{$t('addGroup.back')}}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { addGroup } from "@/api/admin";
import { list } from "@/api/process";
import { mapState } from "vuex";
import { ROUTER_PATH } from "@/constants/common.js";
export default {
  name: "AddRole",
  data() {
    return {
      backupInfo: { companyName: ""},
      processList: [],
      form: {
        groupName: "",
        processID: ""
      },
      rules: {
        groupName: [
          { required: true, message: "请输入组名", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    list({
      userID: this.accountInfo.userID,
      companyID: this.accountInfo.companyID
    }).then((response) => {
      this.processList = response.data.items;
    });
  },
  computed: {
    ...mapState(["accountInfo"])
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          addGroup({
            companyID: this.accountInfo.companyID,
            ...this.form
          }).then(response => {
            this.$message({
              message: response.message,
              type: "success"
            });
            //this.refreshData();
            this.$router.push(ROUTER_PATH.ADMIN_ROLE);
          });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$router.push(ROUTER_PATH.ADMIN_ROLE);
    }
  }
};
</script>
